
import { useNavigate } from 'react-router-dom';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-lg shadow-lg shadow-amber-500/10' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Brand Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 cursor-pointer flex-shrink-0"
          >
            <div className="w-10 h-10 flex items-center justify-center">
              <img
                src="https://storage.readdy-site.link/project_files/2d96c7ea-03ca-4f90-a66b-a881a6a23467/11e329a1-415a-44ab-8899-0ac1238aea4c_Gemini_Generated_Image_yx64hoyx64hoyx64-1.png?v=8e4f1ac532bb393498e97882a0e5b5fc"
                alt="四相AI影視學院"
                className="w-full h-full object-contain"
              />
            </div>
            <span
              className="text-white font-bold tracking-widest text-sm whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              四相AI影視學院
            </span>
          </button>

          <div className="flex items-center gap-12">
            {['about', 'portfolio', 'effects', 'student-works', 'contact'].map((id, i) => {
              const labels = ['關於', '作品', '特效', '學員作品', '聯絡'];
              return (
                <button
                  key={id}
                  onClick={() => scrollToSection(id)}
                  className="text-white/80 hover:text-amber-400 transition-all duration-300 font-light tracking-wider text-sm hover:drop-shadow-[0_0_8px_rgba(251,191,36,0.8)] whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                >
                  {labels[i]}
                </button>
              );
            })}
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-yellow-400 rounded-sm text-black text-sm font-bold tracking-widest hover:shadow-lg hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
          >
            合作洽詢
          </button>
        </div>
      </div>
    </nav>
  );
}
